import React, {useContext, useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiInputList from "../components/Form/UiInputList";
import AuthProvider from "../services/AuthProvider";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";
import {booleanParaEnvio} from "../components/Form/PessoaFields";
import { useNotification } from '../components/Core/NotificationProvider';

const acessoListBase: any = {
    1: 'Master',
    2: 'Vendedor',
    3: 'Supervisor',
    4: 'Administrador',
    5: 'Montador',
};
const acessoList = Object.keys(acessoListBase).map((key) => {
    return { id: key, title: acessoListBase[key] };
})

/**
 * O vendedor é papel mais conta de login: nome, CPF e telefone moram no cadastro de
 * Pessoa, que este form referencia pelo suggest em vez de embutir. Pessoa que ainda
 * não existe se cadastra pela lupa do próprio suggest.
 *
 * O e-mail daqui é o de login (`ven_email`), não o de contato da pessoa. Nível de
 * acesso, supervisor, ativo e senha também são do papel.
 */
export default function VendedorForm(props: any){
    const { user } = useContext<any>(AuthProvider);

    const methods = useForm({
        defaultValues: props.data || { ativo: true }
    });
    const { handleSubmit, watch, setValue, reset } = methods;
    const allData = watch();
    const notification = useNotification();

    useEffect(() => {
        if(user.acesso == 3 && allData?.vendedor?.id != user?.id){
            setValue('supervisor', user);
        }
    }, []);

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    const salvar = (dados: any) => {
        if (!dados.pessoa?.id) {
            notification.error('Vendedor precisa da pessoa');
            return;
        }

        props.triggerSubmit({
            ...dados,
            ativo: booleanParaEnvio(dados.ativo),
        });
    };

    return (
        <>
            <FormProvider {...methods} >
                <Form onSubmit={handleSubmit(salvar)} methods={methods}>
                    <WindowBody>
                        <div className="row">
                            <UiInputSuggest size={9} name="pessoa" router="unpessoa" idField="id" titleField="nome" label="Pessoa"/>
                            <UiInputCheckbox size={3} name="ativo" label="Ativo"/>

                            <UiInputText mask={"lowercase"} size={12} name="email" label="E-mail de login"/>

                            { user.acesso == 1 && <UiInputList size={6} name="acesso" list={acessoList} idField="id" titleField="title" label="Nível de Acesso" /> }
                            { user.acesso == 1 && <UiInputSuggest size={6} router="vendedor" idField="id" titleField="nome" name="supervisor" label="Supervisor"/> }

                            { user.acesso == 1 &&
                                <>
                                    <UiInputCheckbox size={5} name="alterarSenha" label="Alterar senha?"/>
                                    { allData.alterarSenha == true && <UiInputText size={7} name="senha" label="Nova senha"/> }
                                </>
                            }
                        </div>
                    </WindowBody>

                    <WindowFooter>
                        <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                        <UiButton variant="primary" type="submit">Salvar</UiButton>
                    </WindowFooter>
                </Form>
            </FormProvider>
        </>
    )
}
